import { PropsWithChildren, ReactNode } from 'react'
import { cn } from 'cn'

const TemplatesCategoryItem = ({
  isSelected,
  children,
  onClick,
}: PropsWithChildren<{ isSelected: boolean; onClick: () => void }>): ReactNode => {
  return (
    <button
      onClick={onClick}
      className={cn(
        `flex w-full justify-start rounded-lg px-5 py-2.5 whitespace-nowrap outline-hidden main-transition-colors focus-visible:focus-ring-primary`,
        isSelected ? 'bg-bg-accent-active text-text-on' : `text-text-primary hover:text-text-link`,
      )}
    >
      {children}
    </button>
  )
}

export default TemplatesCategoryItem
